import { useEffect, useState } from 'react';
import * as actionCreator from '../../actions';
import { Form, Button, Spinner } from 'react-bootstrap';
import { updateInformation } from '../../api/actions/Session';
import './UserInformation.scss';
import { connect } from 'react-redux';
import { getUserData } from '../../helpers/Session';

const UserInformationForm = ({
    currFirstname,
    currLastname,
    setUserProfile
}) => {
    const [origFirstname, setOrigFirstname] = useState(currFirstname);
    const [origLastname, setOrigLastname] = useState(currLastname);
    const [firstname, setFirstname] = useState(currFirstname);
    const [lastname, setLastname] = useState(currLastname);
    const [isFormValid, setIsFormValid] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    
    const onFirstnameChange = (event) => {
        const { value } = event.target;
        setFirstname(value);
        checkFormValidity(value, lastname);
    };

    const onLastnameChange = (event) => {
        const { value } = event.target;
        setLastname(value);
        checkFormValidity(firstname, value);
    };

    const checkFormValidity = (firstname, lastname) => {
        let valid = !(origFirstname === firstname && origLastname === lastname);
        setIsFormValid(valid);
    };

    useEffect(() => {}, [firstname, lastname, isFormValid]);

    const onSubmit = async (event) => {
        event.preventDefault();
        try {
            setIsSubmitting(true);
            const res = await updateInformation({
                firstname,
                lastname
            });
            const userData = res.data;
            setOrigLastname(userData.lastname);
            setLastname(userData.lastname);
            setOrigFirstname(userData.firstname);
            setFirstname(userData.firstname);
            const profile = await getUserData();
            setUserProfile(profile);
            setIsSubmitting(false);
            setIsFormValid(false)
        } catch (err) {
            console.log(err);
            setIsSubmitting(false);
        }
    };
    
    return (
        <Form onSubmit={onSubmit}>
            <Form.Group className="mb-3">
                <Form.Label>Firstname</Form.Label>
                <Form.Control 
                    type="text" 
                    value={firstname}
                    onChange={onFirstnameChange}
                />
            </Form.Group>
            <Form.Group className="mb-3">
                <Form.Label>Lastname</Form.Label>
                <Form.Control
                    type="text"
                    value={lastname}
                    onChange={onLastnameChange}
                />
            </Form.Group>
            <Button 
                disabled={!isFormValid || isSubmitting}
                variant="primary" 
                type="submit" 
                className="mt-2"
            >
                {isSubmitting ?
                    (
                        <>
                            <Spinner
                                as="span"
                                animation="border"
                                size="sm"
                                role="status"
                                aria-hidden="true"
                                className='me-2'
                            />
                            Updating...
                        </>
                    ) : 
                    (
                        <>Update</>
                    )
                }
            </Button>
        </Form>
    );
};

export default UserInformationForm;
